module.exports = __webpack_public_path__ + "img/time_line_circular_order_1.b8d55e2c.svg";